import React from 'react';
import { Select } from 'antd';
import useSegmentField from 'core/hooks/useSegmentField';

const SelectAccountTypes = (props, ref) => {
  const segmentFields = useSegmentField();
  
  return (
    <Select
      ref={ref}
      {...props}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      <Select.Option key="professional" value="professional">
        {segmentFields.serviceProvider}
      </Select.Option>
      {segmentFields.isHealthcareEnabled && (
        <Select.Option key="student" value="student">
          Estudante
        </Select.Option>
      )}
      <Select.Option key="partnership" value="partnership">
        Parceiro
      </Select.Option>
    </Select>
  );
};

export default React.forwardRef(SelectAccountTypes);

